import * as React from "react";
const SvgLoadingLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 15.667A3.333 3.333 0 1 0 12 9a3.333 3.333 0 0 0 0 6.667m8-1.334a2 2 0 1 0 0-4 2 2 0 0 0 0 4m-16 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4", clipRule: "evenodd" }));
export default SvgLoadingLine;
